import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/api';
import { useTranslation } from 'react-i18next';

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const cleanEmail = email.trim().toLowerCase();
        if (!cleanEmail) {
            setError(t('auth.errors.email_required'));
            return;
        }
        setLoading(true);
        setError('');
        try {
            await authService.forgotPassword(cleanEmail);
            setSuccess(true);
        } catch (err) {
            setError(t('common.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h1>{t('app.name')}</h1>
                <h2>{t('auth.forgot_title')}</h2>

                {success ? (
                    <div>
                        <div className="success-message">
                            {t('auth.forgot_sent')}
                        </div>
                        <Link to="/login" style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}>
                            {t('auth.back_to_login')}
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && <div className="error-message">{error}</div>}

                        <div className="form-group">
                            <label>{t('auth.email')}</label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder={t('auth.placeholders.email_alt')}
                                required
                            />
                        </div>

                        <button type="submit" disabled={loading} className="btn-primary"
                            style={{ width: '100%', padding: '0.85rem', marginTop: '0.5rem' }}>
                            {loading ? t('auth.sending') : t('auth.send_reset_link')}
                        </button>

                        <p className="auth-link">
                            <Link to="/login">{t('auth.back_to_login')}</Link>
                        </p>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ForgotPasswordPage;